/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoModelsSessionDailySummary
 */
export interface FusionMelcoModelsSessionDailySummary {
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsSessionDailySummary
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsSessionDailySummary
     */
    dropped?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsSessionDailySummary
     */
    completed?: number;
}

export function FusionMelcoModelsSessionDailySummaryFromJSON(json: any): FusionMelcoModelsSessionDailySummary {
    return FusionMelcoModelsSessionDailySummaryFromJSONTyped(json, false);
}

export function FusionMelcoModelsSessionDailySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsSessionDailySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'dropped': !exists(json, 'dropped') ? undefined : json['dropped'],
        'completed': !exists(json, 'completed') ? undefined : json['completed'],
    };
}

export function FusionMelcoModelsSessionDailySummaryToJSON(value?: FusionMelcoModelsSessionDailySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'dropped': value.dropped,
        'completed': value.completed,
    };
}


